<template>
    <div class="selfdefine-card" v-if="readyRender" data-spm="selfdefine-card" >
        <iframe :src="iframe_url" :height="pc_height" :width="pc_width" data-spm-type='content'></iframe>
    </div>
</template>

<script>
export default {
    name: 'SelfDefineCard',
    props: {
        cardInfo: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data: function () {
        return {
            cardData: this.cardInfo,
            iframe_url: '',
            pc_height: '',
            pc_width: '100%',
            wap_height: '',
            wap_width: '',
            readyRender: false,
        }
    },
    created() {
        this.getValidData()
    },
    methods: {
        getValidData() {
            const commonJsonStr = this.cardData?.fields?.commonJson
            let commonJson
            try {
                commonJson = JSON.parse(commonJsonStr)?.[0]
            } catch (e) {
                this.validData = ''
                console.log(e)
                return
            }
            const readyIframeCard =
                commonJson?.ename === 'app_factory_iframe_type'
            const commonJsonValues = commonJson?.value
            console.log(commonJson, commonJsonValues, readyIframeCard)
            commonJsonValues.forEach((item) => {
                if (item?.ename === 'iframe_url') {
                    this.iframe_url = item?.value
                }
                if (item?.ename === 'pc_height') {
                    this.pc_height = item?.value
                }
                if (item?.ename === 'pc_width') {
                    this.pc_width = item?.value
                }
                if (item?.ename === 'wap_height') {
                    this.wap_height = item?.value
                }
                if (item?.ename === 'wap_width') {
                    this.wap_width = item?.value
                }
            })
            if (readyIframeCard && this.iframe_url && this.pc_height) {
                this.readyRender = true
                this.$nextTick(() => {
                    window.sohuSpm?.domDidChange({ target: 'selfdefine-card' })
                })
            } else {
                console.log('【自定义功能卡】必填参数缺失，请检查iframe_url、pc_height', this.irame_url, this.pc_height)
            }
        },
    },
}
</script>

<style scoped lang="less">
.selfdefine-card {
    margin:16px 0;
}
</style>
